/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateExamTestDto
 */
export interface CreateUpdateExamTestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTestDto
     */
    examId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTestDto
     */
    testId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateExamTestDto
     */
    lp?: number | null;
}

/**
 * Check if a given object implements the CreateUpdateExamTestDto interface.
 */
export function instanceOfCreateUpdateExamTestDto(value: object): value is CreateUpdateExamTestDto {
    return true;
}

export function CreateUpdateExamTestDtoFromJSON(json: any): CreateUpdateExamTestDto {
    return CreateUpdateExamTestDtoFromJSONTyped(json, false);
}

export function CreateUpdateExamTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateExamTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'examId': json['examId'] == null ? undefined : json['examId'],
        'testId': json['testId'] == null ? undefined : json['testId'],
        'lp': json['lp'] == null ? undefined : json['lp'],
    };
}

export function CreateUpdateExamTestDtoToJSON(value?: CreateUpdateExamTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'examId': value['examId'],
        'testId': value['testId'],
        'lp': value['lp'],
    };
}

